import { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import dayjs from "dayjs";

import request from "../../../utilities/requests";

const EventLogDialog = ({ open, close, eventId }) => {
  const [messages, setMessages] = useState([]);

  useEffect(() => {
    if (open) {
      getMessages();
    }
  }, [open]);

  const getMessages = async () => {
    const url = `communications/eventlog/?eventId=${eventId}`;
    const result = await request(url);
    if (result.success) {
      setMessages(result.data);
    }
  };


  return (
    <Dialog open={open} onClose={close} fullWidth>
      <DialogTitle>Event Communications</DialogTitle>
      <DialogContent>
        {messages.length === 0 ? (
          <DialogContentText>No event messages found.</DialogContentText>
        ) : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>Template/Subject</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Send At</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Channel</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {messages.map((msg) => (
                <TableRow key={msg._id}>
                  <TableCell>{msg.template === 'custom' ? msg.subject : msg.template}</TableCell>
                  <TableCell>
                    {dayjs(msg.sentAt).local().format("MM/DD/YY hh:mm A")}
                  </TableCell>
                  <TableCell>{msg.channel}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={close}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EventLogDialog;
